import ImgMaks from '../images/team-modal/webp/Maks.webp';
import ImgKate from '../images/team-modal/webp/Kateryna.webp';
import ImgAndrii from '../images/team-modal/webp/Andrii.webp';
import ImgAnton from '../images/team-modal/webp/Anton.webp';
import ImgIllya from '../images/team-modal/webp/Ilya.webp';
import ImgVolodymyr from '../images/team-modal/webp/Volodymyr.webp';
import ImgYurii from '../images/team-modal/webp/Yurii.webp';
import ImgGeo from '../images/team-modal/webp/Geo.webp';
import ImgAleks from '../images/team-modal/webp/Aleks.webp';
import ImgNata from '../images/team-modal/webp/Natalya.webp';
import ImgLina from '../images/team-modal/webp/Alina.webp';

export const teamArr = [
  {
    name: 'Maksym',
    image: ImgMaks,
    github: 'https://github.com/makfiz',
    id: 1,
    position: 'Team Lead',
  },
  {
    name: 'Kateryna',
    image: ImgKate,
    github: 'https://github.com/Ekaterina-Kazantseva',
    id: 2,
    position: 'Scrum Master',
  },
  {
    name: 'Andrii',
    image: ImgAndrii,
    github: 'https://github.com/syniuk-a',
    id: 3,
    position: 'Developer',
  },
  {
    name: 'Anton',
    image: ImgAnton,
    github: 'https://github.com/Ex0rc1st',
    id: 4,
    position: 'Developer',
  },
  {
    name: 'Alina',
    image: ImgLina,
    github: 'https://github.com/Alialinaa19',
    id: 5,
    position: 'Developer',
  },
  {
    name: 'Ilya',
    image: ImgIllya,
    github: 'https://github.com/illia-RD',
    id: 6,
    position: 'Developer',
  },
  {
    name: 'Volodymyr',
    image: ImgVolodymyr,
    github: 'https://github.com/Aleks-corp',
    id: 7,
    position: 'Developer',
  },
  {
    name: 'Aleksandr',
    image: ImgAleks,
    github: 'link',
    id: 8,
    position: 'Developer',
  },
  {
    name: 'Yurii',
    image: ImgYurii,
    github: 'link',
    id: 9,
    position: 'Developer',
  },
  {
    name: 'Natalya',
    image: ImgNata,
    github: 'link',
    id: 10,
    position: 'Developer',
  },
  {
    name: 'George',
    image: ImgGeo,
    github: 'https://github.com/WrWl',
    id: 11,
    position: 'Developer',
  },
];
